import { useAws } from "src/networking/aws";
import { useAxios } from "src/networking/axios";

import {
  AwsGateCallbacks,
  AwsGateRequest,
  AxiosGateCallbacks,
  AxiosGateRequest,
  GetCookie,
  PostCertificate,
  PostEvaluatePremium,
} from "src/types";

export const useGetCookie = <
  T extends GetCookie["request"],
  D extends GetCookie["response"]
>() => {
  const hook = useAxios<T, D>("getCookie");
  return {
    ...hook,
    crossGate: (
      request: AxiosGateRequest<T>,
      callbacks: AxiosGateCallbacks<D>
    ) => {
      return hook.crossGate(
        {
          method: "get",
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePostEvaluatePremium = <
  T extends PostEvaluatePremium["request"],
  D extends PostEvaluatePremium["response"]
>() => {
  const hook = useAws<T, D>("postEvaluatePremium");
  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: "/quote/evaluate",
          ...request,
        },
        callbacks
      );
    },
  };
};

export const usePostCertificate = <
  T extends PostCertificate["request"],
  D extends PostCertificate["response"]
>() => {
  const hook = useAws<T, D>("postCertificate");
  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/download-cert/${request.uriParams.idPolizza}?codiceStampa=${request.queryParams.codiceStampa}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
